import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
export const commonPageContainer = (FOUNDATIONS, STATE_TOKENS) => ({
    display: 'flex',
    align_items: 'center',
    justify_content: 'center',
    height: FOUNDATIONS.size_300,
    min_width: FOUNDATIONS.size_300,
    padding: `${FOUNDATIONS.spacing_50} ${FOUNDATIONS.spacing_150}`,
    ...STATE_TOKENS,
    clickable: {
        cursor: 'pointer',
        ...STATE_TOKENS.clickable,
    },
});
const commonIcon = (FOUNDATIONS, STATE_TOKENS) => ({
    width: FOUNDATIONS.size_300,
    height: FOUNDATIONS.size_300,
    color: FOUNDATIONS.color_comp_actions_iconbutton_primary_default_icon,
    ...STATE_TOKENS,
    disabled: {
        width: FOUNDATIONS.size_300,
        height: FOUNDATIONS.size_300,
        color: FOUNDATIONS.color_accent_disabled_icon_100,
        ...STATE_TOKENS?.disabled,
    },
});
export const commonStyles = (FOUNDATIONS, STATE_TOKENS) => ({
    container: {
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        height: 'auto',
        width: 'auto',
        ...STATE_TOKENS.container,
    },
    pagesContainer: {
        display: 'flex',
        align_items: 'center',
        justify_content: 'center',
        height: 'auto',
        width: 'auto',
        column_gap: FOUNDATIONS.spacing_150,
        margin: `0 ${FOUNDATIONS.spacing_250}`,
        ...STATE_TOKENS.pagesContainer,
    },
    paginationLeftArrowIcon: {
        ...commonIcon(FOUNDATIONS, STATE_TOKENS?.paginationLeftArrowIcon),
    },
    paginationRightArrowIcon: {
        ...commonIcon(FOUNDATIONS, STATE_TOKENS?.paginationRightArrowIcon),
    },
    paginationCountersNumber: {
        ...STATE_TOKENS.paginationCountersNumber,
        [DeviceBreakpointsType.LARGE_DESKTOP]: {
            counters: 5,
            ...STATE_TOKENS.paginationCountersNumber?.[DeviceBreakpointsType.LARGE_DESKTOP],
        },
        [DeviceBreakpointsType.DESKTOP]: {
            counters: 5,
            ...STATE_TOKENS.paginationCountersNumber?.[DeviceBreakpointsType.DESKTOP],
        },
        [DeviceBreakpointsType.TABLET]: {
            counters: 5,
            ...STATE_TOKENS.paginationCountersNumber?.[DeviceBreakpointsType.TABLET],
        },
        [DeviceBreakpointsType.MOBILE]: {
            counters: 4,
            ...STATE_TOKENS.paginationCountersNumber?.[DeviceBreakpointsType.MOBILE],
        },
    },
});
//# sourceMappingURL=commonStyles.js.map